// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"ArticlePage_pageWrapper__dH8gV"};